const initialValues = {
  token: "",
  role: "",
  loaderState: false,
  snackBarType: "error",
  snackBarMsg: "",
  cart: [],
  email: "",
  orderTotalAmount: null,
};

export default initialValues;
